<template>
  <div>
    <v-app-bar app elevation="0">
      <template v-if="$vuetify.breakpoint.smAndDown">
        <v-spacer></v-spacer>

        <v-toolbar-items>
          <language-switcher-list-item
            :key="$vuetify.breakpoint.name"
          ></language-switcher-list-item>
          <dark-mode-switcher-list-item></dark-mode-switcher-list-item>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in items"
                :key="index"
                :to="item.link"
              >
                <v-list-item-avatar tile>
                  <v-img :src="item.icon"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </template>

      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            :to="item.link"
          >
            <v-list-item-avatar tile>
              <v-img :src="item.icon"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <language-switcher-list-item></language-switcher-list-item>
          <dark-mode-switcher-list-item></dark-mode-switcher-list-item>
        </v-toolbar-items>
      </template>
    </v-app-bar>
  </div>
</template>

<script>
import DarkModeSwitcherListItem from "./DarkModeSwitcherListItem.vue";
import LanguageSwitcherListItem from "./LanguageSwitcherListItem.vue";
export default {
  components: { DarkModeSwitcherListItem, LanguageSwitcherListItem },
  data() {
    return {
      drawer: false,
      items: [
        {
          title: "sideBarLayout.links[0]",
          icon: require("@/assets/home.png"),
          link: "#acceuil"
        },
        {
          title: "sideBarLayout.links[1]",
          icon: require("@/assets/education.png"),
          link: "#education"
        },
        {
          title: "sideBarLayout.links[2]",
          icon: require("@/assets/works.png"),
          link: "#experience"
        },
        {
          title: "sideBarLayout.links[3]",
          icon: require("@/assets/contact.png"),
          link: "#contact"
        }
      ],
      mini: false
    };
  }
};
</script>
